import { Box, Dialog, Loader } from '@pocketlaw/tetris';
export function DialogLoading() {
    return (<Dialog>
      <Box alignItems="center" justifyContent="center" p="2xl">
        <Loader size={12}/>
      </Box>
    </Dialog>);
}
